export default __webpack_public_path__ + "static/media/iconHome.f2efa9b7.svg";